import { render } from "./TextRadio.vue?vue&type=template&id=944ac4d8&scoped=true"
import script from "./TextRadio.vue?vue&type=script&lang=js"
export * from "./TextRadio.vue?vue&type=script&lang=js"

import "./TextRadio.vue?vue&type=style&index=0&id=944ac4d8&scoped=true&lang=css"

import exportComponent from "/Users/nutsudaploysopon/Desktop/DevFinite/Octopus Co.,Ltd./Ncare/NCare-WebApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-944ac4d8"]])

export default __exports__